import {
  EntityDropdownInputBare,
  type EntityDropdownInputBareProps,
} from "#batteries-included-components/Dropdowns/EntityDropdownInputBare";
import useLocalization from "#src/hooks/useLocalization";
import { FacilityAdapter } from "@validereinc/domain";
import React from "react";

/**
 * Uncontrolled Facility dropdown using DropdownInputBare for use in FilterBuilder.
 * Value is controlled by parent (e.g. filter state); does not register with react-hook-form.
 */
export const FacilityDropdownInputBare = (
  props: Omit<EntityDropdownInputBareProps<unknown>, "fetchEntityList">
) => {
  const { localize } = useLocalization();

  return (
    <EntityDropdownInputBare
      fetchEntityList={FacilityAdapter.getList}
      label={props.label ?? localize("Facility")}
      sort={{
        sortBy: "name",
        sortDirection: "asc",
      }}
      {...props}
    />
  );
};
